(ns graphql.core
  (:require
   [graphql-builder.core :as gql]
   [graphql-builder.parser :refer-macros [defgraphql]]
   [camel-snake-kebab.core :as k]
   [util.core :refer [transform-keys]]))

(defn- reshape-graphql [m]
  {:query (get-in m [:graphql :query])
   :operation-name (get-in m [:graphql :operationName])
   :variables (transform-keys k/->kebab-case-keyword (get-in m [:graphql :variables]))})

(defn- fmt-gql
  "The graphql-builder library returns some non-standard formatted map that has a resolver
  fn and some other properties that we don't want, or are malformed, or misnamed. Instead,
  we reformat their query map into a map of query/mutation-name -> fns. When a fn is invoked
  it will properly pass along :query or :mutation, and returns a well-formed map containing
  the query, the operation name, and any variables."
  [query-map]
  ;; @TODO handle mutations as well as :query
  (assoc {}
         :query (reduce
                 (fn [m [k f]] (assoc m k (fn [args] (reshape-graphql (f args)))))
                 {}
                 (:query query-map))
         :mutation (reduce
                    (fn [m [k f]] (assoc m k (fn [args] (reshape-graphql (f args)))))
                    {}
                    (:mutation query-map))))

(defgraphql parsed
  ;; queries
  "src/graphql/queries/assets.gql"
  "src/graphql/queries/brand.gql"
  "src/graphql/queries/client_accounts_details.gql"
  "src/graphql/queries/client_profile.gql"
  "src/graphql/queries/client_sso.gql"
  "src/graphql/queries/estate.gql"
  "src/graphql/queries/expenses.gql"
  "src/graphql/queries/fetch_client_dashboard.gql"
  "src/graphql/queries/guidebook.gql"
  "src/graphql/queries/impersonate.gql"
  "src/graphql/queries/income.gql"
  "src/graphql/queries/insurance.gql"
  "src/graphql/queries/invite.gql"
  "src/graphql/queries/key_accomplishments.gql"
  "src/graphql/queries/last_updated.gql"
  "src/graphql/queries/liabilities.gql"
  "src/graphql/queries/onboard.gql"
  "src/graphql/queries/partner.gql"
  "src/graphql/queries/priorities.gql"
  "src/graphql/queries/quovo_connections.gql"
  "src/graphql/queries/quovo_token.gql"
  "src/graphql/queries/review.gql"
  "src/graphql/queries/risk_profile.gql"
  "src/graphql/queries/session.gql"
  "src/graphql/queries/tax.gql"
  "src/graphql/queries/valid_client.gql"

  ;; mutations
  "src/graphql/mutations/create_external_account.gql"
  "src/graphql/mutations/create_guidebook_note.gql"
  "src/graphql/mutations/create_key_accomplishments.gql"
  "src/graphql/mutations/create_quovo_account.gql"
  "src/graphql/mutations/create_review.gql"
  "src/graphql/mutations/create_session.gql"
  "src/graphql/mutations/delete_external_account.gql"
  "src/graphql/mutations/delete_quovo_connection.gql"
  "src/graphql/mutations/request_password_reset.gql"
  "src/graphql/mutations/reset_password.gql"
  "src/graphql/mutations/update_accounts.gql"
  "src/graphql/mutations/update_assets.gql"
  "src/graphql/mutations/update_estate.gql"
  "src/graphql/mutations/update_expenses.gql"
  "src/graphql/mutations/update_external_account.gql"
  "src/graphql/mutations/update_income.gql"
  "src/graphql/mutations/update_insurance.gql"
  "src/graphql/mutations/update_liabilities.gql"
  "src/graphql/mutations/update_onboard.gql"
  "src/graphql/mutations/update_personal_information.gql"
  "src/graphql/mutations/update_priorities.gql"
  "src/graphql/mutations/update_profile_photo.gql"
  "src/graphql/mutations/update_risk_profile.gql"
  "src/graphql/mutations/update_tax.gql")

(def queries! (atom (fmt-gql (gql/query-map parsed))))

(defn session
  ([] (session {}))
  ([args] ((get-in @queries! [:query :session]) args :query)))

(defn impersonate
  ([] (impersonate {}))
  ([args] ((get-in @queries! [:query :impersonate]) args :query)))

(defn onboard []
  ((get-in @queries! [:query :onboard])))

(defn invite
  ([] (invite {}))
  ([args] ((get-in @queries! [:query :invite]) args :query)))

(defn guidebook []
  ((get-in @queries! [:query :guidebook])))

(defn last-updated []
  ((get-in @queries! [:query :last-updated])))

(defn client-profile []
  ((get-in @queries! [:query :client-profile])))

(defn risk-profile
  ([] (risk-profile {}))
  ([args] ((get-in @queries! [:query :risk-profile]) args)))

(defn priorities []
  ((get-in @queries! [:query :priorities])))

(defn partner [args]
  ((get-in @queries! [:query :partner]) args))

(defn brand [args]
  ((get-in @queries! [:query :brand]) args))

(defn income []
  ((get-in @queries! [:query :income])))

(defn expenses []
  ((get-in @queries! [:query :expenses])))

(defn assets []
  ((get-in @queries! [:query :assets])))

(defn liabilities []
  ((get-in @queries! [:query :liabilities])))

(defn insurance []
  ((get-in @queries! [:query :insurance])))

(defn estate []
  ((get-in @queries! [:query :estate])))

(defn tax []
  ((get-in @queries! [:query :tax])))

(defn review []
  ((get-in @queries! [:query :review])))

(defn key-accomplishments []
  ((get-in @queries! [:query :key-accomplishments])))

(defn client-accounts-details []
  ((get-in @queries! [:query :client-accounts-details])))

(defn client-sso []
  ((get-in @queries! [:query :client-sso])))

(defn quovo-token []
  ((get-in @queries! [:query :quovo-token])))

(defn fetch-client-dashboard []
  ((get-in @queries! [:query :client-dashboard])))

(defn quovo-connections []
  ((get-in @queries! [:query :quovo-connections])))

(defn create-session [args]
  ((get-in @queries! [:mutation :create-session]) args))

(defn request-password-reset [args]
  ((get-in @queries! [:mutation :request-password-reset]) args))

(defn reset-password [args]
  ((get-in @queries! [:mutation :reset-password]) args))

(defn create-external-account [args]
  ((get-in @queries! [:mutation :create-external-account]) args))

(defn delete-external-account [args]
  ((get-in @queries! [:mutation :delete-external-account]) args))

(defn update-external-account [args]
  ((get-in @queries! [:mutation :update-external-account]) args))

(defn create-guidebook-note [args]
  ((get-in @queries! [:mutation :create-guidebook-note]) args))

(defn update-personal-information [args]
  ((get-in @queries! [:mutation :update-personal-information]) args))

(defn update-priorities [args]
  ((get-in @queries! [:mutation :update-priorities]) args))

(defn create-quovo-account [args]
  ((get-in @queries! [:mutation :create-quovo-account]) args))

(defn delete-quovo-connection [args]
  ((get-in @queries! [:mutation :delete-quovo-connection]) args))

(defn update-profile-photo [args]
  ((get-in @queries! [:mutation :update-profile-photo]) args))

(defn- update-assets [args]
  ((get-in @queries! [:mutation :update-assets]) args))

(defn- update-liabilities [args]
  ((get-in @queries! [:mutation :update-liabilities]) args))

(defn update-insurance [args]
  ((get-in @queries! [:mutation :update-insurance]) args))

(defn update-risk-profile [args]
  ((get-in @queries! [:mutation :update-risk-profile]) args))

(defn update-expenses [args]
  ((get-in @queries! [:mutation :update-expenses]) args))

(defn update-income [args]
  ((get-in @queries! [:mutation :update-income]) args))

(defn update-estate [args]
  ((get-in @queries! [:mutation :update-estate]) args))

(defn update-tax [args]
  ((get-in @queries! [:mutation :update-tax]) args))

(defn update-onboard [args]
  ((get-in @queries! [:mutation :update-onboard]) args))

(defn update-accounts []
  ((get-in @queries! [:mutation :update-accounts])))

(defn create-review [args]
  ((get-in @queries! [:mutation :create-review]) args))

(defn create-key-accomplishments [args]
  ((get-in @queries! [:mutation :create-key-accomplishments]) args))

(defn valid-client [args]
  ((get-in @queries! [:query :valid-client]) args))
